import * as Yup from "yup"

const validateProjectSchema = Yup.object({
    title: Yup.string().required("Please enter a project title"),
    description: Yup.string().required("Please enter a project description"),
})

export default validateProjectSchema
